export type FieldReport = {
	reportId: number;
	msId: number;
	siteName: string;
	staffName: string;
	poId: number;
	performedAt: string;
	deploymentType: DeploymentTypeEnum;
	deploymentTypeId: number;
	notes: string;
	hasExternalAntennas: boolean | null;
	swapReason: SWAP_REASONS | null;
};

export type DeploymentType = {
	id: number;
	deploymentType: string;
};

export enum DeploymentTypeEnum {
	FRESH_DEPLOYMENT = 'FRESH_DEPLOYMENT',
	LANDOWNER_ACQUISITION = 'LANDOWNER_ACQUISITION',
	MAINTENANCE_CHARGING = 'MAINTENANCE_CHARGING',
	MAINTENANCE_CONNECTIVITY = 'MAINTENANCE_CONNECTIVITY',
	MAINTENANCE_GENERAL = 'MAINTENANCE_GENERAL',
	MAINTENANCE_GPS = 'MAINTENANCE_GPS',
	OTHER = 'OTHER',
	TOTAL_STATION = 'TOTAL_STATION'
}

export const deploymentTypeLabels: Record<keyof typeof DeploymentTypeEnum, string> = {
	[DeploymentTypeEnum.FRESH_DEPLOYMENT]: 'Fresh Deployment',
	[DeploymentTypeEnum.LANDOWNER_ACQUISITION]: 'Landowner Acquisition',
	[DeploymentTypeEnum.MAINTENANCE_CHARGING]: 'Maintenance Charging',
	[DeploymentTypeEnum.MAINTENANCE_CONNECTIVITY]: 'Maintenance Connectivity',
	[DeploymentTypeEnum.MAINTENANCE_GENERAL]: 'Maintenance General',
	[DeploymentTypeEnum.MAINTENANCE_GPS]: 'Maintenance GPS',
	[DeploymentTypeEnum.OTHER]: 'Other',
	[DeploymentTypeEnum.TOTAL_STATION]: 'Total Station'
};



export enum SWAP_REASONS {
	WATER = 'WATER',
	SIGNAL_CELLULAR = 'SIGNAL_CELLULAR',
	SIGNAL_GNSS = 'SIGNAL_GNSS',
	SOLAR = 'SOLAR',
	THEFT_VANDALISM = 'THEFT_VANDALISM',
	ANIMAL_INTERFERENCE = 'ANIMAL_INTERFERENCE',
	OTHER = 'OTHER',
	NOT_A_SWAP = 'NOT_A_SWAP'
}

export const SWAP_REASONS_LABELS = {
	[SWAP_REASONS.NOT_A_SWAP]: 'Not a Swap Operation',
	[SWAP_REASONS.WATER]: 'Water',
	[SWAP_REASONS.SIGNAL_CELLULAR]: 'Signal Cellular',
	[SWAP_REASONS.SIGNAL_GNSS]: 'Signal GNSS',
	[SWAP_REASONS.SOLAR]: 'Solar',
	[SWAP_REASONS.THEFT_VANDALISM]: 'Theft / Vandalism',
	[SWAP_REASONS.ANIMAL_INTERFERENCE]: 'Animal Interference',
	[SWAP_REASONS.OTHER]: 'Other'
} as const;

export const SWAP_REASONS_LIST = Object.entries(SWAP_REASONS_LABELS).map(([key, value]) => ({
	id: key,
	label: value
}));